import axios from 'axios';
import { Message } from 'element-ui';
import { reportError } from '../plugins/owl.js'
function resolvePath(url) {
  if (!url) return 'unknown'
  const resolvePathRE = /\.com\/([^?]*)\??/
  const path = url.match(resolvePathRE)
  if (path && path[1]) {
    return path[1]
  }
  return url
}
const request = axios.create({
  baseURL: process.env.BASE_URL, // api的基本url，也可以直接写定好的url
  timeout: 5000 // 请求超时时间
});

request.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';

// Add request interceptor
request.interceptors.request.use(
  // Do something before request is sent
  config => {
    return config
  },
  // Do something with request error
  error => {
    reportError('request-error', error)
    return Promise.reject(error)
  }
)

request.interceptors.response.use(res => { // 成功请求到数据
  // 这里根据后端提供的数据进行对应的处理
  if (res.data.code === 200) {
    return res.data;
  } else if (res.data.code === 401 || res.code === 401) {
    const { href } = window.location;
    if (href.includes('/console')) {
      const { host } = window.location;
      window.location.href = (window.location.protocol + host + '/passport/logout?web_url=' + encodeURIComponent(window.location.href))
    } else {
      return res.data;
    }
  } else {
    Message.error(res.data.msg);
  }
}, error => {
  const config = error.config || {}
  const path = resolvePath(config && config.url)
  reportError(`${path}response-error`, error)
  return Promise.reject(error)
})

export default {
  post(url, data, settings = { showToast: false }) {
    return request
      .post(url, data)
      .then((res) => {
        if (settings.showToast) {
          Message.success(res.message);
        }
        return res.data; // 响应体中数据
      })
      .catch((error) => {
        // Message.error(error);
        throw error;
      });
  },
  get(url, data, settings = { showToast: false }) {
    return request
      .get(url, {
        params: data
      })
      .then((res) => {
        // const body = res.data; // 响应体
        if (settings.showToast) {
          Message.success(res.message);
        }
        return res.data; // 响应体中数据
      })
      .catch((error) => {
        // Message.error(error);
        throw error;
      });
  }
}
